import { Box } from '@chakra-ui/react/box'
import { IconButton } from '@chakra-ui/react/button'
import { Flex } from '@chakra-ui/react/flex'
import { dismissModal } from '@el5/native-api'

import ArrowLeftIcon from '@/icons/ArrowLeftIcon'
import X5ClubIcon from '@/icons/X5ClubIcon'

import classes from './styles.module.css'

interface Props {
  hideBackButton?: boolean
}

export function Header({ hideBackButton }: Props) {
  return (
    <Flex
      as="header"
      className={classes.header}
      justifyContent={hideBackButton ? 'center' : 'space-between'}
    >
      {!hideBackButton && (
        <IconButton
          role="button"
          aria-label="вернуться назад"
          onClick={() => dismissModal()}
          variant="plain"
          className={classes.backBtn}
        >
          <ArrowLeftIcon />
        </IconButton>
      )}

      <X5ClubIcon
        className={classes.logoIcon}
        role="img"
        aria-label="X5 Клуб"
      />
      {!hideBackButton && <Box className={classes.placeholder} />}
    </Flex>
  )
}
